const GemQueryKeys = {
  global: ["gems"] as const,
  leaders: (period?: string) =>
    [...GemQueryKeys.global, "leaders", period || "monthly"] as const,
  profile: () => [...GemQueryKeys.global, "profile"] as const,
};

export { GemQueryKeys };
